/**
 * Email templates for frontend use
 * These templates are duplicates of the Edge Function templates for inline use
 */

interface ReservationConfirmationData {
  userName: string;
  lessonTitle: string;
  lessonDate: string;
  lessonTime: string;
  lessonType: "group" | "private" | "pair";
  instructor?: string;
}

export function getReservationConfirmationTemplate(
  data: ReservationConfirmationData,
): string {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { 
          font-family: 'Nunito', Arial, sans-serif; 
          line-height: 1.6; 
          color: #1a1a1a;
          margin: 0;
          padding: 0;
          background-color: #ffffff;
        }
        .container { 
          max-width: 600px; 
          margin: 0 auto; 
          background-color: #ffffff;
        }
        .header { 
          background-color: #870509; 
          color: #ffffff; 
          padding: 24px 20px; 
          text-align: center;
          border-radius: 12px 12px 0 0;
        }
        .header h1 {
          margin: 0;
          font-size: 28px;
          font-weight: 700;
        }
        .header p {
          margin: 8px 0 0 0;
          font-size: 14px;
          opacity: 0.9;
        }
        .content { 
          padding: 32px 24px; 
          background-color: #ffffff;
        }
        .content h2 {
          margin: 0 0 16px 0;
          font-size: 22px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .content p {
          margin: 0 0 12px 0;
          font-size: 16px;
          color: #4a4a4a;
        }
        .info-box { 
          background-color: #ffffff; 
          padding: 20px; 
          margin: 20px 0; 
          border-left: 4px solid #870509;
          border: 1px solid #e5e5e5;
          border-radius: 8px;
          border-left-width: 4px;
        }
        .info-box h3 {
          margin: 0 0 12px 0;
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .info-box p {
          margin: 8px 0;
          font-size: 15px;
          color: #4a4a4a;
        }
        .footer { 
          text-align: center; 
          padding: 24px 20px; 
          color: #666; 
          font-size: 12px;
          background-color: #f9fafb;
          border-top: 1px solid #e5e5e5;
          border-radius: 0 0 12px 12px;
        }
        .footer p {
          margin: 4px 0;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>AC Academy</h1>
          <p>Tanečný systém</p>
        </div>
        <div class="content">
          <h2>Potvrdenie rezervácie</h2>
          <p>Ahoj <strong>${data.userName}</strong>,</p>
          <p>Ďakujeme za rezerváciu lekcie!</p>
          
          <div class="info-box">
            <h3>Detaily lekcie:</h3>
            <p><strong>Názov:</strong> ${data.lessonTitle}</p>
            <p><strong>Dátum:</strong> ${data.lessonDate}</p>
            <p><strong>Čas:</strong> ${data.lessonTime}</p>
            <p><strong>Typ:</strong> ${data.lessonType === "group" ? "Skupinová lekcia" : data.lessonType === "private" ? "Súkromná lekcia" : "Párová lekcia"}</p>
            ${data.instructor ? `<p><strong>Inštruktor:</strong> ${data.instructor}</p>` : ""}
          </div>
          
          <p>Teším sa na vás na lekcii!</p>
          <p>V prípade otázok ma kontaktujte.</p>
          
          <p style="margin-top: 24px;">
            S pozdravom,<br>
            <strong>Andreas Ayo Cruz, MSc., MBA</strong>
          </p>
        </div>
        <div class="footer">
          <p>© 2026 AC Academy. Všetky práva vyhradené.</p>
          <p><a href="https://www.ayocruz.com" style="color: #870509; text-decoration: none;">www.ayocruz.com</a></p>
          <p>Tento email bol odoslaný automaticky, prosím neodpovedajte.</p>
        </div>
      </div>
    </body>
    </html>
  `;
}

interface CancellationConfirmationData {
  userName: string;
  lessonTitle: string;
  lessonDate: string;
  lessonTime: string;
  lessonType: "group" | "private" | "pair";
  instructor?: string;
  reason?: string;
}

export function getCancellationConfirmationTemplate(
  data: CancellationConfirmationData,
): string {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { 
          font-family: 'Nunito', Arial, sans-serif; 
          line-height: 1.6; 
          color: #1a1a1a;
          margin: 0;
          padding: 0;
          background-color: #ffffff;
        }
        .container { 
          max-width: 600px; 
          margin: 0 auto; 
          background-color: #ffffff;
        }
        .header { 
          background-color: #870509; 
          color: #ffffff; 
          padding: 24px 20px; 
          text-align: center;
          border-radius: 12px 12px 0 0;
        }
        .header h1 {
          margin: 0;
          font-size: 28px;
          font-weight: 700;
        }
        .header p {
          margin: 8px 0 0 0;
          font-size: 14px;
          opacity: 0.9;
        }
        .content { 
          padding: 32px 24px; 
          background-color: #ffffff;
        }
        .content h2 {
          margin: 0 0 16px 0;
          font-size: 22px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .content p {
          margin: 0 0 12px 0;
          font-size: 16px;
          color: #4a4a4a;
        }
        .info-box { 
          background-color: #ffffff; 
          padding: 20px; 
          margin: 20px 0; 
          border-left: 4px solid #870509;
          border: 1px solid #e5e5e5;
          border-radius: 8px;
          border-left-width: 4px;
        }
        .info-box h3 {
          margin: 0 0 12px 0;
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .info-box p {
          margin: 8px 0;
          font-size: 15px;
          color: #4a4a4a;
        }
        .footer { 
          text-align: center; 
          padding: 24px 20px; 
          color: #666; 
          font-size: 12px;
          background-color: #f9fafb;
          border-top: 1px solid #e5e5e5;
          border-radius: 0 0 12px 12px;
        }
        .footer p {
          margin: 4px 0;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>AC Academy</h1>
          <p>Tanečný systém</p>
        </div>
        <div class="content">
          <h2>Potvrdenie zrušenia rezervácie</h2>
          <p>Ahoj <strong>${data.userName}</strong>,</p>
          <p>Vaša rezervácia bola úspešne zrušená.</p>
          
          <div class="info-box">
            <h3>Detaily zrušenej lekcie:</h3>
            <p><strong>Názov:</strong> ${data.lessonTitle}</p>
            <p><strong>Dátum:</strong> ${data.lessonDate}</p>
            <p><strong>Čas:</strong> ${data.lessonTime}</p>
            <p><strong>Typ:</strong> ${data.lessonType === "group" ? "Skupinová lekcia" : data.lessonType === "private" ? "Súkromná lekcia" : "Párová lekcia"}</p>
            ${data.instructor ? `<p><strong>Inštruktor:</strong> ${data.instructor}</p>` : ""}
            ${data.reason ? `<p><strong>Dôvod zrušenia:</strong> ${data.reason}</p>` : ""}
          </div>
          
          <p>Ak máte záujem, môžete si rezervovať inú lekciu kedykoľvek.</p>
          <p>V prípade otázok ma kontaktujte.</p>
          
          <p style="margin-top: 24px;">
            S pozdravom,<br>
            <strong>Andreas Ayo Cruz, MSc., MBA</strong>
          </p>
        </div>
        <div class="footer">
          <p>© 2026 AC Academy. Všetky práva vyhradené.</p>
          <p><a href="https://www.ayocruz.com" style="color: #870509; text-decoration: none;">www.ayocruz.com</a></p>
          <p>Tento email bol odoslaný automaticky, prosím neodpovedajte.</p>
        </div>
      </div>
    </body>
    </html>
  `;
}

interface PrivateLessonRequestData {
  userName: string;
  lessonDate: string;
  lessonTime: string;
  durationHours: number;
  lessonType: "single" | "pair";
  danceStyle?: string;
  notes?: string;
}

export function getPrivateLessonRequestTemplate(
  data: PrivateLessonRequestData,
): string {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { 
          font-family: 'Nunito', Arial, sans-serif; 
          line-height: 1.6; 
          color: #1a1a1a;
          margin: 0;
          padding: 0;
          background-color: #ffffff;
        }
        .container { 
          max-width: 600px; 
          margin: 0 auto; 
          background-color: #ffffff;
        }
        .header { 
          background-color: #870509; 
          color: #ffffff; 
          padding: 24px 20px; 
          text-align: center;
          border-radius: 12px 12px 0 0;
        }
        .header h1 {
          margin: 0;
          font-size: 28px;
          font-weight: 700;
        }
        .header p {
          margin: 8px 0 0 0;
          font-size: 14px;
          opacity: 0.9;
        }
        .content { 
          padding: 32px 24px; 
          background-color: #ffffff;
        }
        .content h2 {
          margin: 0 0 16px 0;
          font-size: 22px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .content p {
          margin: 0 0 12px 0;
          font-size: 16px;
          color: #4a4a4a;
        }
        .info-box { 
          background-color: #ffffff; 
          padding: 20px; 
          margin: 20px 0; 
          border-left: 4px solid #870509;
          border: 1px solid #e5e5e5;
          border-radius: 8px;
          border-left-width: 4px;
        }
        .info-box h3 {
          margin: 0 0 12px 0;
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .info-box p {
          margin: 8px 0;
          font-size: 15px;
          color: #4a4a4a;
        }
        .status-box { 
          background-color: #fef1f1; 
          padding: 20px; 
          margin: 20px 0; 
          border-left: 4px solid #870509;
          border: 1px solid #fec5c5;
          border-radius: 8px;
          border-left-width: 4px;
        }
        .status-box p {
          margin: 4px 0;
          font-size: 15px;
          color: #6b0407;
        }
        .footer { 
          text-align: center; 
          padding: 24px 20px; 
          color: #666; 
          font-size: 12px;
          background-color: #f9fafb;
          border-top: 1px solid #e5e5e5;
          border-radius: 0 0 12px 12px;
        }
        .footer p {
          margin: 4px 0;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>AC Academy</h1>
          <p>Tanečný systém</p>
        </div>
        <div class="content">
          <h2>Požiadavka na súkromnú lekciu</h2>
          <p>Ahoj <strong>${data.userName}</strong>,</p>
          <p>Vaša požiadavka na súkromnú lekciu bola prijatá!</p>
          
          <div class="info-box">
            <h3>Detaily požiadavky:</h3>
            <p><strong>Dátum:</strong> ${data.lessonDate}</p>
            <p><strong>Čas:</strong> ${data.lessonTime}</p>
            <p><strong>Trvanie:</strong> ${data.durationHours} ${data.durationHours === 1 ? "hodina" : "hodín"}</p>
            <p><strong>Typ:</strong> ${data.lessonType === "single" ? "Individuálna lekcia" : "Párová lekcia"}</p>
            ${data.danceStyle ? `<p><strong>Tanečný štýl:</strong> ${data.danceStyle}</p>` : ""}
            ${data.notes ? `<p><strong>Poznámky:</strong> ${data.notes}</p>` : ""}
          </div>
          
          <div class="status-box">
            <p style="margin-bottom: 8px;"><strong>Status:</strong> Čaká na schválenie</p>
            <p style="margin: 0;">Vašu požiadavku skontrolujeme a o schválení vás budeme informovať.</p>
          </div>
          
          <p>V prípade otázok ma kontaktujte.</p>
          
          <p style="margin-top: 24px;">
            S pozdravom,<br>
            <strong>Andreas Ayo Cruz, MSc., MBA</strong>
          </p>
        </div>
        <div class="footer">
          <p>© 2026 AC Academy. Všetky práva vyhradené.</p>
          <p><a href="https://www.ayocruz.com" style="color: #870509; text-decoration: none;">www.ayocruz.com</a></p>
          <p>Tento email bol odoslaný automaticky, prosím neodpovedajte.</p>
        </div>
      </div>
    </body>
    </html>
  `;
}

interface PrivateLessonApprovalData {
  userName: string;
  lessonDate: string;
  lessonTime: string;
  durationHours: number;
  lessonType: "single" | "pair";
  instructor?: string;
}

export function getPrivateLessonApprovalTemplate(
  data: PrivateLessonApprovalData,
): string {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { 
          font-family: 'Nunito', Arial, sans-serif; 
          line-height: 1.6; 
          color: #1a1a1a;
          margin: 0;
          padding: 0;
          background-color: #ffffff;
        }
        .container { 
          max-width: 600px; 
          margin: 0 auto; 
          background-color: #ffffff;
        }
        .header { 
          background-color: #870509; 
          color: #ffffff; 
          padding: 24px 20px; 
          text-align: center;
          border-radius: 12px 12px 0 0;
        }
        .header h1 {
          margin: 0;
          font-size: 28px;
          font-weight: 700;
        }
        .header p {
          margin: 8px 0 0 0;
          font-size: 14px;
          opacity: 0.9;
        }
        .content { 
          padding: 32px 24px; 
          background-color: #ffffff;
        }
        .content h2 {
          margin: 0 0 16px 0;
          font-size: 22px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .content p {
          margin: 0 0 12px 0;
          font-size: 16px;
          color: #4a4a4a;
        }
        .info-box { 
          background-color: #ffffff; 
          padding: 20px; 
          margin: 20px 0; 
          border-left: 4px solid #870509;
          border: 1px solid #e5e5e5;
          border-radius: 8px;
          border-left-width: 4px;
        }
        .info-box h3 {
          margin: 0 0 12px 0;
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .info-box p {
          margin: 8px 0;
          font-size: 15px;
          color: #4a4a4a;
        }
        .success-box { 
          background-color: #d1fae5; 
          padding: 20px; 
          margin: 20px 0; 
          border-left: 4px solid #10b981;
          border: 1px solid #86efac;
          border-radius: 8px;
          border-left-width: 4px;
        }
        .success-box p {
          margin: 4px 0;
          font-size: 15px;
          color: #065f46;
        }
        .footer { 
          text-align: center; 
          padding: 24px 20px; 
          color: #666; 
          font-size: 12px;
          background-color: #f9fafb;
          border-top: 1px solid #e5e5e5;
          border-radius: 0 0 12px 12px;
        }
        .footer p {
          margin: 4px 0;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>AC Academy</h1>
          <p>Tanečný systém</p>
        </div>
        <div class="content">
          <h2>Súkromná lekcia schválená</h2>
          <p>Ahoj <strong>${data.userName}</strong>,</p>
          <p>Vaša žiadosť bola schválená!</p>
          
          <div class="success-box">
            <p style="margin: 0;"><strong>• Lekcia je potvrdená</strong></p>
          </div>
          
          <div class="info-box">
            <h3>Detaily schválenej lekcie:</h3>
            <p><strong>Dátum:</strong> ${data.lessonDate}</p>
            <p><strong>Čas:</strong> ${data.lessonTime}</p>
            <p><strong>Trvanie:</strong> ${data.durationHours} ${data.durationHours === 1 ? "hodina" : "hodín"}</p>
            <p><strong>Typ:</strong> ${data.lessonType === "single" ? "Individuálna lekcia" : "Párová lekcia"}</p>
            ${data.instructor ? `<p><strong>Inštruktor:</strong> ${data.instructor}</p>` : ""}
          </div>
          
          <p>Teším sa na vás na lekcii!</p>
          <p>V prípade otázok ma kontaktujte.</p>
          
          <p style="margin-top: 24px;">
            S pozdravom,<br>
            <strong>Andreas Ayo Cruz, MSc., MBA</strong>
          </p>
        </div>
        <div class="footer">
          <p>© 2026 AC Academy. Všetky práva vyhradené.</p>
          <p><a href="https://www.ayocruz.com" style="color: #870509; text-decoration: none;">www.ayocruz.com</a></p>
          <p>Tento email bol odoslaný automaticky, prosím neodpovedajte.</p>
        </div>
      </div>
    </body>
    </html>
  `;
}

interface PrivateLessonCompletionData {
  userName: string;
  lessonDate: string;
  lessonTime: string;
  durationHours: number;
  lessonType: "single" | "pair";
  instructor?: string;
}

export function getPrivateLessonCompletionTemplate(
  data: PrivateLessonCompletionData,
): string {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { 
          font-family: 'Nunito', Arial, sans-serif; 
          line-height: 1.6; 
          color: #1a1a1a;
          margin: 0;
          padding: 0;
          background-color: #ffffff;
        }
        .container { 
          max-width: 600px; 
          margin: 0 auto; 
          background-color: #ffffff;
        }
        .header { 
          background-color: #870509; 
          color: #ffffff; 
          padding: 24px 20px; 
          text-align: center;
          border-radius: 12px 12px 0 0;
        }
        .header h1 {
          margin: 0;
          font-size: 28px;
          font-weight: 700;
        }
        .header p {
          margin: 8px 0 0 0;
          font-size: 14px;
          opacity: 0.9;
        }
        .content { 
          padding: 32px 24px; 
          background-color: #ffffff;
        }
        .content h2 {
          margin: 0 0 16px 0;
          font-size: 22px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .content p {
          margin: 0 0 12px 0;
          font-size: 16px;
          color: #4a4a4a;
        }
        .info-box { 
          background-color: #ffffff; 
          padding: 20px; 
          margin: 20px 0; 
          border-left: 4px solid #870509;
          border: 1px solid #e5e5e5;
          border-radius: 8px;
          border-left-width: 4px;
        }
        .info-box h3 {
          margin: 0 0 12px 0;
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .info-box p {
          margin: 8px 0;
          font-size: 15px;
          color: #4a4a4a;
        }
        .success-box { 
          background-color: #fef1f1; 
          padding: 20px; 
          margin: 20px 0; 
          border-left: 4px solid #870509;
          border: 1px solid #fec5c5;
          border-radius: 8px;
          border-left-width: 4px;
        }
        .success-box p {
          margin: 4px 0;
          font-size: 15px;
          color: #6b0407;
        }
        .footer { 
          text-align: center; 
          padding: 24px 20px; 
          color: #666; 
          font-size: 12px;
          background-color: #f9fafb;
          border-top: 1px solid #e5e5e5;
          border-radius: 0 0 12px 12px;
        }
        .footer p {
          margin: 4px 0;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>AC Academy</h1>
          <p>Tanečný systém</p>
        </div>
        <div class="content">
          <h2>Súkromná lekcia dokončená</h2>
          <p>Ahoj <strong>${data.userName}</strong>,</p>
          <p>Vaša súkromná lekcia bola úspešne dokončená!</p>
          
          <div class="success-box">
            <p style="margin: 0;"><strong>• Lekcia je dokončená</strong></p>
          </div>
          
          <div class="info-box">
            <h3>Detaily dokončenej lekcie:</h3>
            <p><strong>Dátum:</strong> ${data.lessonDate}</p>
            <p><strong>Čas:</strong> ${data.lessonTime}</p>
            <p><strong>Trvanie:</strong> ${data.durationHours} ${data.durationHours === 1 ? "hodina" : "hodín"}</p>
            <p><strong>Typ:</strong> ${data.lessonType === "single" ? "Individuálna lekcia" : "Párová lekcia"}</p>
            ${data.instructor ? `<p><strong>Inštruktor:</strong> ${data.instructor}</p>` : ""}
          </div>
          
          <p>Ďakujeme za vašu účasť na lekcii!</p>
          <p>Ak máte záujem o ďalšie lekcie, môžete si ich rezervovať kedykoľvek.</p>
          <p>V prípade otázok ma kontaktujte.</p>
          
          <p style="margin-top: 24px;">
            S pozdravom,<br>
            <strong>Andreas Ayo Cruz, MSc., MBA</strong>
          </p>
        </div>
        <div class="footer">
          <p>© 2026 AC Academy. Všetky práva vyhradené.</p>
          <p><a href="https://www.ayocruz.com" style="color: #870509; text-decoration: none;">www.ayocruz.com</a></p>
          <p>Tento email bol odoslaný automaticky, prosím neodpovedajte.</p>
        </div>
      </div>
    </body>
    </html>
  `;
}

interface PrivateLessonCancellationData {
  userName: string;
  lessonDate: string;
  lessonTime: string;
  durationHours: number;
  lessonType: "single" | "pair";
  reason?: string;
}

export function getPrivateLessonCancellationTemplate(
  data: PrivateLessonCancellationData,
): string {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { 
          font-family: 'Nunito', Arial, sans-serif; 
          line-height: 1.6; 
          color: #1a1a1a;
          margin: 0;
          padding: 0;
          background-color: #ffffff;
        }
        .container { 
          max-width: 600px; 
          margin: 0 auto; 
          background-color: #ffffff;
        }
        .header { 
          background-color: #870509; 
          color: #ffffff; 
          padding: 24px 20px; 
          text-align: center;
          border-radius: 12px 12px 0 0;
        }
        .header h1 {
          margin: 0;
          font-size: 28px;
          font-weight: 700;
        }
        .header p {
          margin: 8px 0 0 0;
          font-size: 14px;
          opacity: 0.9;
        }
        .content { 
          padding: 32px 24px; 
          background-color: #ffffff;
        }
        .content h2 {
          margin: 0 0 16px 0;
          font-size: 22px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .content p {
          margin: 0 0 12px 0;
          font-size: 16px;
          color: #4a4a4a;
        }
        .info-box { 
          background-color: #ffffff; 
          padding: 20px; 
          margin: 20px 0; 
          border-left: 4px solid #870509;
          border: 1px solid #e5e5e5;
          border-radius: 8px;
          border-left-width: 4px;
        }
        .info-box h3 {
          margin: 0 0 12px 0;
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .info-box p {
          margin: 8px 0;
          font-size: 15px;
          color: #4a4a4a;
        }
        .footer { 
          text-align: center; 
          padding: 24px 20px; 
          color: #666; 
          font-size: 12px;
          background-color: #f9fafb;
          border-top: 1px solid #e5e5e5;
          border-radius: 0 0 12px 12px;
        }
        .footer p {
          margin: 4px 0;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>AC Academy</h1>
          <p>Tanečný systém</p>
        </div>
        <div class="content">
          <h2>Súkromná lekcia zrušená</h2>
          <p>Ahoj <strong>${data.userName}</strong>,</p>
          <p>Vaša súkromná lekcia bola zrušená.</p>
          
          <div class="info-box">
            <h3>Detaily zrušenej lekcie:</h3>
            <p><strong>Dátum:</strong> ${data.lessonDate}</p>
            <p><strong>Čas:</strong> ${data.lessonTime}</p>
            <p><strong>Trvanie:</strong> ${data.durationHours} ${data.durationHours === 1 ? "hodina" : "hodín"}</p>
            <p><strong>Typ:</strong> ${data.lessonType === "single" ? "Individuálna lekcia" : "Párová lekcia"}</p>
            ${data.reason ? `<p><strong>Dôvod zrušenia:</strong> ${data.reason}</p>` : ""}
          </div>
          
          <p>Ak máte záujem, môžete si zarezervovať novú súkromnú lekciu kedykoľvek.</p>
          <p>V prípade otázok ma kontaktujte.</p>
          
          <p style="margin-top: 24px;">
            S pozdravom,<br>
            <strong>Andreas Ayo Cruz, MSc., MBA</strong>
          </p>
        </div>
        <div class="footer">
          <p>© 2026 AC Academy. Všetky práva vyhradené.</p>
          <p><a href="https://www.ayocruz.com" style="color: #870509; text-decoration: none;">www.ayocruz.com</a></p>
          <p>Tento email bol odoslaný automaticky, prosím neodpovedajte.</p>
        </div>
      </div>
    </body>
    </html>
  `;
}

interface PackagePurchaseData {
  userName: string;
  packageName: string;
  packageType: string;
  totalHours: number;
  price: number;
  currency: string;
  newBalance: number;
}

export function getPackagePurchaseTemplate(data: PackagePurchaseData): string {
  const packageTypeLabel =
    data.packageType === "group"
      ? "Skupinové kurzy"
      : data.packageType === "private_single"
        ? "Individuálne hodiny"
        : data.packageType === "private_pair"
          ? "Párové hodiny"
          : "Hodiny";

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { 
          font-family: 'Nunito', Arial, sans-serif; 
          line-height: 1.6; 
          color: #1a1a1a;
          margin: 0;
          padding: 0;
          background-color: #ffffff;
        }
        .container { 
          max-width: 600px; 
          margin: 0 auto; 
          background-color: #ffffff;
        }
        .header { 
          background-color: #870509; 
          color: #ffffff; 
          padding: 24px 20px; 
          text-align: center;
          border-radius: 12px 12px 0 0;
        }
        .header h1 {
          margin: 0;
          font-size: 28px;
          font-weight: 700;
        }
        .header p {
          margin: 8px 0 0 0;
          font-size: 14px;
          opacity: 0.9;
        }
        .content { 
          padding: 32px 24px; 
          background-color: #ffffff;
        }
        .content h2 {
          margin: 0 0 16px 0;
          font-size: 22px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .content p {
          margin: 0 0 12px 0;
          font-size: 16px;
          color: #4a4a4a;
        }
        .info-box { 
          background-color: #ffffff; 
          padding: 20px; 
          margin: 20px 0; 
          border-left: 4px solid #870509;
          border: 1px solid #e5e5e5;
          border-radius: 8px;
          border-left-width: 4px;
        }
        .info-box h3 {
          margin: 0 0 12px 0;
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .info-box p {
          margin: 8px 0;
          font-size: 15px;
          color: #4a4a4a;
        }
        .success-box { 
          background-color: #d1fae5; 
          padding: 20px; 
          margin: 20px 0; 
          border-left: 4px solid #10b981;
          border: 1px solid #86efac;
          border-radius: 8px;
          border-left-width: 4px;
        }
        .success-box p {
          margin: 4px 0;
          font-size: 15px;
          color: #065f46;
        }
        .warning-box { 
          background-color: #fef1f1; 
          padding: 20px; 
          margin: 20px 0; 
          border-left: 4px solid #870509;
          border: 1px solid #fec5c5;
          border-radius: 8px;
          border-left-width: 4px;
        }
        .warning-box h3 {
          margin: 0 0 12px 0;
          font-size: 18px;
          font-weight: 600;
          color: #6b0407;
        }
        .warning-box p {
          margin: 8px 0;
          font-size: 15px;
          color: #6b0407;
        }
        .footer { 
          text-align: center; 
          padding: 24px 20px; 
          color: #666; 
          font-size: 12px;
          background-color: #f9fafb;
          border-top: 1px solid #e5e5e5;
          border-radius: 0 0 12px 12px;
        }
        .footer p {
          margin: 4px 0;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>AC Academy</h1>
          <p>Tanečný systém</p>
        </div>
        <div class="content">
          <h2>Potvrdenie nákupu balíka</h2>
          <p>Ahoj <strong>${data.userName}</strong>,</p>
          <p>Ďakujeme za nákup balíka hodín!</p>
          
          <div class="success-box">
            <p style="margin: 0;"><strong>• Nákup úspešný</strong></p>
          </div>
          
          <div class="info-box">
            <h3>Detaily balíka:</h3>
            <p><strong>Názov:</strong> ${data.packageName}</p>
            <p><strong>Typ:</strong> ${packageTypeLabel}</p>
            <p><strong>Počet hodín:</strong> ${data.totalHours}</p>
            <p><strong>Cena:</strong> ${data.price} ${data.currency}</p>
          </div>
          
          <div class="warning-box">
            <h3>• Platba v hotovosti na mieste</h3>
            <p>Prosím uhraďte platbu v hotovosti pri najbližšej návšteve tanečnej školy.</p>
            <p>Po uhradení platby budete môcť rezervovať lekcie a použiť vaše hodiny.</p>
          </div>
          
          <div class="info-box">
            <h3>Nový zostatok:</h3>
            <p><strong>Dostupné hodiny:</strong> ${data.newBalance} ${data.newBalance === 1 ? "hodina" : data.newBalance < 5 ? "hodiny" : "hodín"}</p>
            <p><em>Hodiny budú aktivované po úhrade platby</em></p>
          </div>
          
          <p>V prípade otázok ma kontaktujte.</p>
          
          <p style="margin-top: 24px;">
            S pozdravom,<br>
            <strong>Andreas Ayo Cruz, MSc., MBA</strong>
          </p>
        </div>
        <div class="footer">
          <p>© 2026 AC Academy. Všetky práva vyhradené.</p>
          <p><a href="https://www.ayocruz.com" style="color: #870509; text-decoration: none;">www.ayocruz.com</a></p>
          <p>Tento email bol odoslaný automaticky, prosím neodpovedajte.</p>
        </div>
      </div>
    </body>
    </html>
  `;
}

interface PaymentConfirmationData {
  userName: string;
  transactionId: number;
  packageName: string;
  packageType: string;
  totalHours: number;
  amount: number;
  currency: string;
  transactionDate: string;
  reference?: string;
}

export function getPaymentConfirmationTemplate(
  data: PaymentConfirmationData,
): string {
  const packageTypeLabel =
    data.packageType === "group"
      ? "Skupinové kurzy"
      : data.packageType === "private_single"
        ? "Individuálne hodiny"
        : data.packageType === "private_pair"
          ? "Párové hodiny"
          : "Hodiny";

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { 
          font-family: 'Nunito', Arial, sans-serif; 
          line-height: 1.6; 
          color: #1a1a1a;
          margin: 0;
          padding: 0;
          background-color: #ffffff;
        }
        .container { 
          max-width: 600px; 
          margin: 0 auto; 
          background-color: #ffffff;
        }
        .header { 
          background-color: #870509; 
          color: #ffffff; 
          padding: 24px 20px; 
          text-align: center;
          border-radius: 12px 12px 0 0;
        }
        .header h1 {
          margin: 0;
          font-size: 28px;
          font-weight: 700;
        }
        .header p {
          margin: 8px 0 0 0;
          font-size: 14px;
          opacity: 0.9;
        }
        .content { 
          padding: 32px 24px; 
          background-color: #ffffff;
        }
        .content h2 {
          margin: 0 0 16px 0;
          font-size: 22px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .content p {
          margin: 0 0 12px 0;
          font-size: 16px;
          color: #4a4a4a;
        }
        .info-box { 
          background-color: #ffffff; 
          padding: 20px; 
          margin: 20px 0; 
          border-left: 4px solid #870509;
          border: 1px solid #e5e5e5;
          border-radius: 8px;
          border-left-width: 4px;
        }
        .info-box h3 {
          margin: 0 0 12px 0;
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .info-box p {
          margin: 8px 0;
          font-size: 15px;
          color: #4a4a4a;
        }
        .success-box { 
          background-color: #d1fae5; 
          padding: 20px; 
          margin: 20px 0; 
          border-left: 4px solid #10b981;
          border: 1px solid #86efac;
          border-radius: 8px;
          border-left-width: 4px;
        }
        .success-box p {
          margin: 4px 0;
          font-size: 15px;
          color: #065f46;
        }
        .footer { 
          text-align: center; 
          padding: 24px 20px; 
          color: #666; 
          font-size: 12px;
          background-color: #f9fafb;
          border-top: 1px solid #e5e5e5;
          border-radius: 0 0 12px 12px;
        }
        .footer p {
          margin: 4px 0;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>AC Academy</h1>
          <p>Tanečný systém</p>
        </div>
        <div class="content">
          <h2>Potvrdenie platby</h2>
          <p>Ahoj <strong>${data.userName}</strong>,</p>
          <p>Vaša platba bola úspešne prijatá a potvrdená!</p>
          
          <div class="success-box">
            <p style="margin-bottom: 8px;"><strong>• Platba prijatá</strong></p>
            <p style="margin: 0;">Vaše hodiny sú teraz aktivované a môžete ich používať na rezerváciu lekcií.</p>
          </div>
          
          <div class="info-box">
            <h3>Detaily platby:</h3>
            <p><strong>Číslo objednávky:</strong> #${data.transactionId}</p>
            <p><strong>Balík:</strong> ${data.packageName}</p>
            <p><strong>Typ:</strong> ${packageTypeLabel}</p>
            <p><strong>Počet hodín:</strong> ${data.totalHours} ${data.totalHours === 1 ? "hodina" : "hodín"}</p>
            <p><strong>Suma:</strong> ${data.amount.toFixed(2)} ${data.currency}</p>
            <p><strong>Dátum:</strong> ${data.transactionDate}</p>
            ${data.reference ? `<p><strong>Referencia:</strong> ${data.reference}</p>` : ""}
          </div>
          
          <div class="info-box">
            <h3>Ďalšie kroky:</h3>
            <p>• Vaše hodiny sú aktívne</p>
            <p>• Môžete si rezervovať lekcie</p>
            <p>• Môžete používať hodiny z vášho balíka</p>
          </div>
          
          <p>Ďakujeme za váš nákup a tešíme sa na vás na lekciách!</p>
          <p>V prípade otázok ma kontaktujte.</p>
          
          <p style="margin-top: 24px;">
            S pozdravom,<br>
            <strong>Andreas Ayo Cruz, MSc., MBA</strong>
          </p>
        </div>
        <div class="footer">
          <p>© 2026 AC Academy. Všetky práva vyhradené.</p>
          <p><a href="https://www.ayocruz.com" style="color: #870509; text-decoration: none;">www.ayocruz.com</a></p>
          <p>Tento email bol odoslaný automaticky, prosím neodpovedajte.</p>
        </div>
      </div>
    </body>
    </html>
  `;
}

interface LessonReminderData {
  userName: string;
  lessonTitle: string;
  lessonDate: string;
  lessonTime: string;
  lessonType: "group" | "private" | "pair";
  instructor?: string;
  location?: string;
}

interface AvailabilitySlotNotificationData {
  userName: string;
  slotDate: string;
  slotTime: string;
  slotDuration: string;
  instructor?: string;
  location?: string;
  note?: string;
}

interface AvailabilitySlotsBatchNotificationData {
  userName: string;
  slots: Array<{
    date: string;
    time: string;
    duration: string;
  }>;
  instructor?: string;
  location?: string;
  note?: string;
}

export function getAvailabilitySlotNotificationTemplate(
  data: AvailabilitySlotNotificationData,
): string {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { 
          font-family: 'Nunito', Arial, sans-serif; 
          line-height: 1.6; 
          color: #1a1a1a;
          margin: 0;
          padding: 0;
          background-color: #ffffff;
        }
        .container { 
          max-width: 600px; 
          margin: 0 auto; 
          background-color: #ffffff;
        }
        .header { 
          background-color: #870509; 
          color: #ffffff; 
          padding: 24px 20px; 
          text-align: center;
          border-radius: 12px 12px 0 0;
        }
        .header h1 {
          margin: 0;
          font-size: 28px;
          font-weight: 700;
        }
        .header p {
          margin: 8px 0 0 0;
          font-size: 14px;
          opacity: 0.9;
        }
        .content {
          padding: 32px 24px;
          background-color: #ffffff;
        }
        .content h2 {
          color: #870509;
          margin-top: 0;
          font-size: 24px;
          font-weight: 700;
        }
        .info-box {
          background-color: #f8f9fa;
          border-left: 4px solid #870509;
          padding: 20px;
          margin: 24px 0;
          border-radius: 4px;
        }
        .info-box h3 {
          margin-top: 0;
          color: #870509;
          font-size: 18px;
        }
        .info-box p {
          margin: 8px 0;
        }
        .slots-list {
          margin: 16px 0;
        }
        .slot-item {
          padding: 12px;
          margin: 8px 0;
          background-color: #ffffff;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
        }
        .slot-item strong {
          color: #870509;
        }
        .button {
          display: inline-block;
          background-color: #870509;
          color: #ffffff;
          padding: 12px 24px;
          text-decoration: none;
          border-radius: 6px;
          margin: 24px 0;
          font-weight: 600;
        }
        .footer {
          background-color: #f8f9fa;
          padding: 20px;
          text-align: center;
          font-size: 12px;
          color: #666;
          border-radius: 0 0 12px 12px;
        }
        .footer p {
          margin: 4px 0;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>AC Academy</h1>
          <p>Tanečný systém</p>
        </div>
        <div class="content">
          <h2>Nová dostupnosť pre súkromné lekcie</h2>
          <p>Ahoj <strong>${data.userName}</strong>,</p>
          <p>Máme pre vás dobrú správu! Bola vytvorená nová dostupnosť pre súkromné lekcie.</p>
          
          <div class="info-box">
            <h3>Detaily dostupnosti:</h3>
            <p><strong>Dátum:</strong> ${data.slotDate}</p>
            <p><strong>Čas:</strong> ${data.slotTime}</p>
            <p><strong>Trvanie:</strong> ${data.slotDuration}</p>
            ${data.instructor ? `<p><strong>Inštruktor:</strong> ${data.instructor}</p>` : ""}
            ${data.location ? `<p><strong>Miesto:</strong> ${data.location}</p>` : ""}
            ${data.note ? `<p><strong>Poznámka:</strong> ${data.note}</p>` : ""}
          </div>
          
          <p>Ak máte záujem o rezerváciu tejto dostupnosti, prosím prihláste sa do systému a vytvorte požiadavku na súkromnú lekciu.</p>
          
          <a href="https://app.ayocruz.com/user/private-lessons" class="button">Rezervovať lekciu</a>
          
          <p style="margin-top: 24px;">
            S pozdravom,<br>
            <strong>Andreas Ayo Cruz, MSc., MBA</strong>
          </p>
        </div>
        <div class="footer">
          <p>© 2026 AC Academy. Všetky práva vyhradené.</p>
          <p><a href="https://www.ayocruz.com" style="color: #870509; text-decoration: none;">www.ayocruz.com</a></p>
          <p>Tento email bol odoslaný automaticky, prosím neodpovedajte.</p>
        </div>
      </div>
    </body>
    </html>
  `;
}

export function getAvailabilitySlotsBatchNotificationTemplate(
  data: AvailabilitySlotsBatchNotificationData,
): string {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { 
          font-family: 'Nunito', Arial, sans-serif; 
          line-height: 1.6; 
          color: #1a1a1a;
          margin: 0;
          padding: 0;
          background-color: #ffffff;
        }
        .container { 
          max-width: 600px; 
          margin: 0 auto; 
          background-color: #ffffff;
        }
        .header { 
          background-color: #870509; 
          color: #ffffff; 
          padding: 24px 20px; 
          text-align: center;
          border-radius: 12px 12px 0 0;
        }
        .header h1 {
          margin: 0;
          font-size: 28px;
          font-weight: 700;
        }
        .header p {
          margin: 8px 0 0 0;
          font-size: 14px;
          opacity: 0.9;
        }
        .content {
          padding: 32px 24px;
          background-color: #ffffff;
        }
        .content h2 {
          color: #870509;
          margin-top: 0;
          font-size: 24px;
          font-weight: 700;
        }
        .info-box {
          background-color: #f8f9fa;
          border-left: 4px solid #870509;
          padding: 20px;
          margin: 24px 0;
          border-radius: 4px;
        }
        .info-box h3 {
          margin-top: 0;
          color: #870509;
          font-size: 18px;
        }
        .slots-list {
          margin: 16px 0;
        }
        .slot-item {
          padding: 12px;
          margin: 8px 0;
          background-color: #ffffff;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
        }
        .slot-item strong {
          color: #870509;
        }
        .button {
          display: inline-block;
          background-color: #870509;
          color: #ffffff;
          padding: 12px 24px;
          text-decoration: none;
          border-radius: 6px;
          margin: 24px 0;
          font-weight: 600;
        }
        .footer {
          background-color: #f8f9fa;
          padding: 20px;
          text-align: center;
          font-size: 12px;
          color: #666;
          border-radius: 0 0 12px 12px;
        }
        .footer p {
          margin: 4px 0;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>AC Academy</h1>
          <p>Tanečný systém</p>
        </div>
        <div class="content">
          <h2>Nové dostupnosti pre súkromné lekcie</h2>
          <p>Ahoj <strong>${data.userName}</strong>,</p>
          <p>Máme pre vás dobrú správu! Boli vytvorené nové dostupnosti pre súkromné lekcie.</p>
          
          <div class="info-box">
            <h3>Zoznam dostupných termínov (${data.slots.length}):</h3>
            <div class="slots-list">
              ${data.slots
                .map(
                  (slot) => `
                <div class="slot-item">
                  <p style="margin: 0;"><strong>${slot.date}</strong> o ${slot.time} (${slot.duration})</p>
                </div>
              `,
                )
                .join("")}
            </div>
            ${data.instructor ? `<p style="margin-top: 16px;"><strong>Inštruktor:</strong> ${data.instructor}</p>` : ""}
            ${data.location ? `<p><strong>Miesto:</strong> ${data.location}</p>` : ""}
            ${data.note ? `<p><strong>Poznámka:</strong> ${data.note}</p>` : ""}
          </div>
          
          <p>Ak máte záujem o rezerváciu niektorej z týchto dostupností, prosím prihláste sa do systému a vytvorte požiadavku na súkromnú lekciu.</p>
          
          <a href="https://app.ayocruz.com/user/private-lessons" class="button">Rezervovať lekciu</a>
          
          <p style="margin-top: 24px;">
            S pozdravom,<br>
            <strong>Andreas Ayo Cruz, MSc., MBA</strong>
          </p>
        </div>
        <div class="footer">
          <p>© 2026 AC Academy. Všetky práva vyhradené.</p>
          <p><a href="https://www.ayocruz.com" style="color: #870509; text-decoration: none;">www.ayocruz.com</a></p>
          <p>Tento email bol odoslaný automaticky, prosím neodpovedajte.</p>
        </div>
      </div>
    </body>
    </html>
  `;
}

export function getLessonReminderTemplate(data: LessonReminderData): string {
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { 
          font-family: 'Nunito', Arial, sans-serif; 
          line-height: 1.6; 
          color: #1a1a1a;
          margin: 0;
          padding: 0;
          background-color: #ffffff;
        }
        .container { 
          max-width: 600px; 
          margin: 0 auto; 
          background-color: #ffffff;
        }
        .header { 
          background-color: #870509;
          color: #ffffff; 
          padding: 24px 20px; 
          text-align: center;
          border-radius: 12px 12px 0 0;
        }
        .header h1 {
          margin: 0;
          font-size: 28px;
          font-weight: 700;
        }
        .header p {
          margin: 8px 0 0 0;
          font-size: 14px;
          opacity: 0.9;
        }
        .content { 
          padding: 32px 24px; 
          background-color: #ffffff;
        }
        .content h2 {
          margin: 0 0 16px 0;
          font-size: 22px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .content p {
          margin: 0 0 12px 0;
          font-size: 16px;
          color: #4a4a4a;
        }
        .info-box { 
          background-color: #ffffff; 
          padding: 20px; 
          margin: 20px 0; 
          border-left: 4px solid #870509;
          border: 1px solid #e5e5e5;
          border-radius: 8px;
          border-left-width: 4px;
        }
        .info-box h3 {
          margin: 0 0 12px 0;
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .info-box p {
          margin: 8px 0;
          font-size: 15px;
          color: #4a4a4a;
        }
        .reminder-box { 
          background-color: #fef1f1; 
          padding: 20px; 
          margin: 20px 0; 
          border-left: 4px solid #870509;
          border: 1px solid #fec5c5;
          border-radius: 8px;
          border-left-width: 4px;
        }
        .reminder-box p {
          margin: 4px 0;
          font-size: 15px;
          color: #6b0407;
        }
        .footer { 
          text-align: center; 
          padding: 24px 20px; 
          color: #666; 
          font-size: 12px;
          background-color: #f9fafb;
          border-top: 1px solid #e5e5e5;
          border-radius: 0 0 12px 12px;
        }
        .footer p {
          margin: 4px 0;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>AC Academy</h1>
          <p>Tanečný systém</p>
        </div>
        <div class="content">
          <h2>Pripomienka na lekciu</h2>
          <p>Ahoj <strong>${data.userName}</strong>,</p>
          <p>Rádi by sme vás pripomneli, že máte zajtra rezervovanú lekciu!</p>
          
          <div class="reminder-box">
            <p style="margin-bottom: 8px;"><strong>• Lekcia za 24 hodín</strong></p>
            <p style="margin: 0;">Prosíme, nezabudnite sa pridať včas.</p>
          </div>
          
          <div class="info-box">
            <h3>Detaily lekcie:</h3>
            <p><strong>Názov:</strong> ${data.lessonTitle}</p>
            <p><strong>Dátum:</strong> ${data.lessonDate}</p>
            <p><strong>Čas:</strong> ${data.lessonTime}</p>
            <p><strong>Typ:</strong> ${data.lessonType === "group" ? "Skupinová lekcia" : data.lessonType === "private" ? "Súkromná lekcia" : "Párová lekcia"}</p>
            ${data.instructor ? `<p><strong>Inštruktor:</strong> ${data.instructor}</p>` : ""}
            ${data.location ? `<p><strong>Miesto:</strong> ${data.location}</p>` : ""}
          </div>
          
          <p>Teším sa na vás na lekcii!</p>
          
          <p>V prípade, že sa nemôžete zúčastniť, prosíme zrušte rezerváciu včas.</p>
          
          <p style="margin-top: 24px;">
            S pozdravom,<br>
            <strong>Andreas Ayo Cruz, MSc., MBA</strong>
          </p>
        </div>
        <div class="footer">
          <p>© 2026 AC Academy. Všetky práva vyhradené.</p>
          <p><a href="https://www.ayocruz.com" style="color: #870509; text-decoration: none;">www.ayocruz.com</a></p>
          <p>Tento email bol odoslaný automaticky, prosím neodpovedajte.</p>
        </div>
      </div>
    </body>
    </html>
  `;
}

interface DanceGroupInvitationData {
  inviteeName: string;
  inviterName: string;
  groupName: string;
  groupDescription?: string;
  danceStyles: string[];
  preferredDay?: string;
  preferredTime?: string;
  invitationLink?: string;
}

export interface PairInvitationData {
  inviteeName: string;
  inviterName: string;
  invitationLink?: string;
}

export function getPairInvitationTemplate(data: PairInvitationData): string {
  const acceptLink =
    data.invitationLink || "https://app.ayocruz.com/user/pairs";

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { font-family: 'Nunito', Arial, sans-serif; line-height: 1.6; color: #1a1a1a; margin: 0; padding: 0; }
        .container { max-width: 600px; margin: 0 auto; }
        .header { background-color: #870509; color: #ffffff; padding: 24px 20px; text-align: center; border-radius: 12px 12px 0 0; }
        .header h1 { margin: 0; font-size: 28px; }
        .content { padding: 32px 24px; }
        .content h2 { margin: 0 0 16px 0; font-size: 22px; }
        .button { display: inline-block; padding: 12px 24px; background-color: #870509; color: #ffffff; text-decoration: none; border-radius: 6px; font-weight: 600; margin: 16px 0; }
        .footer { text-align: center; padding: 24px; color: #666; font-size: 12px; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header"><h1>AC Academy</h1><p>Tanečný systém</p></div>
        <div class="content">
          <h2>Pozvánka na tanečný pár</h2>
          <p>Ahoj <strong>${data.inviteeName}</strong>,</p>
          <p><strong>${data.inviterName}</strong> vás pozýva ako tanečného partnera pre párové lekcie.</p>
          <p>Ak máte záujem vytvoriť s ním/ňou pár, prihláste sa do aplikácie a prijmite pozvánku:</p>
          <div style="text-align: center;"><a href="${acceptLink}" class="button">Prijať pozvánku</a></div>
          <p style="margin-top: 24px;">S pozdravom,<br><strong>AC Academy</strong></p>
        </div>
        <div class="footer"><p>© 2026 AC Academy. Tento email bol odoslaný automaticky.</p></div>
      </div>
    </body>
    </html>
  `;
}

export function getDanceGroupInvitationTemplate(
  data: DanceGroupInvitationData,
): string {
  // Použiť produkčnú URL pre emailové pozvánky
  // Ak nie je poskytnutý invitationLink, použiť produkčnú URL
  const acceptLink =
    data.invitationLink || "https://app.ayocruz.com/user/dance-groups";

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { 
          font-family: 'Nunito', Arial, sans-serif; 
          line-height: 1.6; 
          color: #1a1a1a;
          margin: 0;
          padding: 0;
          background-color: #ffffff;
        }
        .container { 
          max-width: 600px; 
          margin: 0 auto; 
          background-color: #ffffff;
        }
        .header { 
          background-color: #870509; 
          color: #ffffff; 
          padding: 24px 20px; 
          text-align: center;
          border-radius: 12px 12px 0 0;
        }
        .header h1 {
          margin: 0;
          font-size: 28px;
          font-weight: 700;
        }
        .header p {
          margin: 8px 0 0 0;
          font-size: 14px;
          opacity: 0.9;
        }
        .content { 
          padding: 32px 24px; 
          background-color: #ffffff;
        }
        .content h2 {
          margin: 0 0 16px 0;
          font-size: 22px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .content p {
          margin: 0 0 12px 0;
          font-size: 16px;
          color: #4a4a4a;
        }
        .info-box { 
          background-color: #ffffff; 
          padding: 20px; 
          margin: 20px 0; 
          border-left: 4px solid #870509;
          border: 1px solid #e5e5e5;
          border-radius: 8px;
          border-left-width: 4px;
        }
        .info-box h3 {
          margin: 0 0 12px 0;
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
        }
        .info-box p {
          margin: 8px 0;
          font-size: 15px;
          color: #4a4a4a;
        }
        .button {
          display: inline-block;
          padding: 12px 24px;
          background-color: #870509;
          color: #ffffff;
          text-decoration: none;
          border-radius: 6px;
          font-weight: 600;
          margin: 16px 0;
        }
        .button:hover {
          background-color: #6b1616;
        }
        .footer { 
          text-align: center; 
          padding: 24px 20px; 
          color: #666; 
          font-size: 12px;
          background-color: #f9fafb;
          border-top: 1px solid #e5e5e5;
          border-radius: 0 0 12px 12px;
        }
        .footer p {
          margin: 4px 0;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>AC Academy</h1>
          <p>Tanečný systém</p>
        </div>
        <div class="content">
          <h2>Pozvánka do skupiny</h2>
          <p>Ahoj <strong>${data.inviteeName}</strong>,</p>
          <p><strong>${data.inviterName}</strong> vás pozýva do skupiny <strong>"${data.groupName}"</strong>!</p>
          
          <div class="info-box">
            <h3>Informácie o skupine:</h3>
            ${data.groupDescription ? `<p><strong>Popis:</strong> ${data.groupDescription}</p>` : ""}
            ${data.danceStyles.length > 0 ? `<p><strong>Tanecné štýly:</strong> ${data.danceStyles.join(", ")}</p>` : ""}
            ${data.preferredDay ? `<p><strong>Preferovaný deň:</strong> ${data.preferredDay}</p>` : ""}
            ${data.preferredTime ? `<p><strong>Preferovaný čas:</strong> ${data.preferredTime}</p>` : ""}
          </div>
          
          <p>Ak máte záujem sa pridať do tejto skupiny, kliknite na tlačidlo nižšie:</p>
          
          <div style="text-align: center;">
            <a href="${acceptLink}" class="button">Prijať pozvánku</a>
          </div>
          
          <p style="margin-top: 24px;">
            S pozdravom,<br>
            <strong>Andreas Ayo Cruz, MSc., MBA</strong>
          </p>
        </div>
        <div class="footer">
          <p>© 2026 AC Academy. Všetky práva vyhradené.</p>
          <p><a href="https://www.ayocruz.com" style="color: #870509; text-decoration: none;">www.ayocruz.com</a></p>
          <p>Tento email bol odoslaný automaticky, prosím neodpovedajte.</p>
        </div>
      </div>
    </body>
    </html>
  `;
}

interface InviteUserData {
  inviteeEmail: string;
  appLink: string;
}

/**
 * Šablóna pre pozvánku nového používateľa do AC Academy (admin pozýva).
 * Obsahuje odkaz na prihlásenie cez Google OAuth.
 */
export function getInviteUserTemplate(data: InviteUserData): string {
  const appLink = data.appLink || "https://app.ayocruz.com";
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <style>
        body { font-family: 'Nunito', Arial, sans-serif; line-height: 1.6; color: #1a1a1a; margin: 0; padding: 0; }
        .container { max-width: 600px; margin: 0 auto; }
        .header { background-color: #870509; color: #ffffff; padding: 24px 20px; text-align: center; border-radius: 12px 12px 0 0; }
        .header h1 { margin: 0; font-size: 28px; }
        .content { padding: 32px 24px; }
        .content h2 { margin: 0 0 16px 0; font-size: 22px; }
        .button { display: inline-block; padding: 12px 24px; background-color: #870509; color: #ffffff !important; text-decoration: none; border-radius: 6px; font-weight: 600; margin: 16px 0; }
        .footer { text-align: center; padding: 24px; color: #666; font-size: 12px; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header"><h1>AC Academy</h1><p>Tanečný systém</p></div>
        <div class="content">
          <h2>Pozvánka do AC Academy</h2>
          <p>Ahoj,</p>
          <p>Boli ste pozvaní do tanečnej aplikácie <strong>AC Academy</strong>.</p>
          <p>Pre vstup sa prihláste cez Google (použite e‑mail <strong>${data.inviteeEmail}</strong>):</p>
          <div style="text-align: center;"><a href="${appLink}" class="button">Vstúpiť do aplikácie</a></div>
          <p style="margin-top: 24px;">S pozdravom,<br><strong>AC Academy</strong></p>
        </div>
        <div class="footer"><p>© 2026 AC Academy. Tento email bol odoslaný automaticky.</p></div>
      </div>
    </body>
    </html>
  `;
}
